// export class SetUserStateRequest {
//     public UserId: number
//     public Inactive: boolean
//     public ChangedByUser: number

// }

export class AddUserRequest {
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    workPhone: string;
    mobilePhone: string;
    menuRole: number;
}

export class UpdateUserRequest {
    userId: number;
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    workPhone: string;
    mobilePhone: string;
    menuRole: number;
    version: number;
    inactive: boolean;
}

export class UpdateComplianceUserRequest {
    userId: number;
    createdById: number;
    version: number; // CWS User Version
    payload: CompliancePayload;
}

export class CompliancePayload {
    compliance1:boolean;
    compliance2:boolean;
    compliance3:boolean;
    compliance4:boolean;
}